module.exports = __webpack_public_path__ + "img/shopify.b8fba873.png";